import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsTaskAddComp from "./Component/TsTaskAddComp"


const TsTaskAdd =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsTaskAddComp />
        </div>
        <Footer />
        </>
    )
}

export default TsTaskAdd